const HTTP_ERROR_MESSAGES: Record<number, string> = {
  400: "That request wasn't valid.",
  401: "You're not logged in.",
  403: "You don't have permission to do this.",
  404: "Not found.",
  409: "That conflicts with something that already exists.",
  413: "That's too large.",
  429: "Too many requests - try again shortly.",
  500: "Something went wrong on the server.",
  502: "Something went wrong on the server.",
  503: "The server is temporarily unavailable.",
  504: "The server took too long to respond.",
};

/** Plain-language fallback for an HTTP status with no server-provided message. */
export function httpErrorMessage(status: number): string {
  return HTTP_ERROR_MESSAGES[status] ?? `Request failed (${status}).`;
}

/** Fetch and parse a JSON response. Throws a plain-language error on non-OK. */
export async function fetchJson<T>(url: string, opts?: RequestInit): Promise<T> {
  const res = await fetch(url, opts);
  if (!res.ok) throw new Error(httpErrorMessage(res.status));
  return (await res.json()) as T;
}
